import { useState, useRef } from "react";
import styled from "styled-components";
import { Paper, Grid, Box, Toolbar } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { AccordionItem } from "./components/AccordionItem";
import { DateTimePicker } from "components/shared/Form";
import { ButtonSubmit, ButtonCancel, SearchInput, Select, Loading, } from "components/shared";
import { useCorreios } from "hooks";
import { IOrder, IAddressee } from "config/interfaces";
import { convertDateTimeISOWithTimeZoneEND, convertDate } from "utils";
import { Pagination } from "@mui/material";
import TableCorreiosDownload from "../tables/TableCorreiosDownload";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    searchInput: {
      width: "50%",
    },
    toolbar: {
      paddingBottom: theme.spacing(2),
      borderRadius: "4px",
      background: "var(--backgroundContent)",
      width: "100%",
      "& .MuiToolbar-regular": {
        padding: 0,
      },
    },
    table: {
      borderRadius: "4px",
      background: "var(--backgroundContent)",
      width: "100%",
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      maxWidth: "calc(100% - 12px)",
    },
    input: {
      "& .MuiInputBase-input": {
        boxShadow: "none",
        fontSize: "1.2rem",
        fontWeight: "500",
        textTransform: "uppercase",
      },
    },
    checkbox: {
      "&.MuiCheckbox-colorSecondary.Mui-checked": {
        color: "var(--orange)",
      },
      "& .MuiSvgIcon-root": {
        width: "1.4rem",
      },
    },
    "@media (max-width: 600px)": {
      searchInput: {
        width: "100%",
      },
    },
  })
);
interface TableProps {
  title?: string;
}

const filters: IOrder.SelectField[] = [
  {
    label: "PERÍODO",
    value: "period",
  },
  {
    label: "LOG",
    value: "status",
  },
];

const SelectedItems = styled.span`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1.2rem;
`;

interface DataState {
  filter: string | null;
  dateFrom: Date;
  dateTo: Date;
  status?: number | undefined;
  dateOf?: string;
}

const today = new Date();
const initialState: DataState = {
  filter: null,
  dateFrom: new Date(today.setDate(today.getDate() - 30)),
  dateTo: new Date(),
  status: 500,
};

export default function CorreiosTemplate({ title }: TableProps) {
  const [data, setData] = useState(initialState);
  const [search, setSearch] = useState("");
  
  const {
    loading,
    IDMCM,
    eventsOptions,
    recentEvents,
    getEventsByFilters,
    setReqBody,
    getQtyEvents,
    eventsLength,
    setLoading,
    currentPage,
  } = useCorreios();

  let inputSearchRef = useRef<HTMLInputElement | null>(null);

  const classes = useStyles();

  const filterItens = (list: IAddressee.Addressee[]) => {
    
    if (!search) return recentEvents;

    let filtered:[] = [];

    const search_lc= search.toLowerCase();
    
    recentEvents.map((item) => {
      let nome:string = (item['NMUSUARIO'] as string)?.toLowerCase();
      let telefone: string = (item['TELEFONE'] as string)?.toLowerCase();
      let complemento: string = (item['ENDECOMPL'] as string)?.toLowerCase();
      
      if(nome?.includes(search_lc) || telefone?.includes(search_lc) || complemento?.includes(search_lc)){
         filtered.push(item);
      }
    })

    return filtered;
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, checked } = event.target;

    const newState = { ...data, [name]: value ? value : checked };
    setData(newState);
  };

  const handleFilterClick = () => {
    // setPage(0);
    switch (data.filter) {
      case "status":
        if (data.status) {
          return getEventsByFilters(data.status);
        } else {
          return;
        }
      case "period":
        // if (search) {
        //   params = {
        //     NMUSUARIO: search.toLocaleUpperCase(),
        //   };
        // }
        return setReqBody({
          DTINI: convertDateTimeISOWithTimeZoneEND(data.dateFrom),
          DTFIM: convertDateTimeISOWithTimeZoneEND(data.dateTo),
        });
      default:
        return alert("deu ruim");
    }
  };

  const handleDateChange = (value: any, name: string) => {
    if (name) {
      setData({ ...data, [name]: value });
    }
  };

  const handleCancelFilter = () => {
    setData({ ...data, filter: null });
    setSearch("");
    getQtyEvents();
  };

  const pagination = () => {
    return (
      <Pagination
        className="pags"
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
        count={eventsLength?Math.round(eventsLength/25):0}
        size="large"
        page={currentPage}
        defaultPage={0}
        onChange={(_e, page) => {
          // console.log(`Página selecionada ${page}`)
          /*localStorage.setItem(
            '@backofficeModulockerMultiLojas:pagination',
            (page - 1).toString()
          );*/
          setLoading(true);
          getQtyEvents(page);
        }}
      />
    );
  };  

  return (
    <>
      {IDMCM && (
        <>
          <Paper className={classes.toolbar} elevation={0}>
            
            <Grid container justifyContent="space-between">
              
              <Grid item md={6} lg={5} xl={4} className={classes.searchInput}>
                <SearchInput
                  ref={inputSearchRef}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="USUÁRIO OU COMPLEMENTO"
                />
              </Grid>

              <Grid item md={6} lg={5} xl={4}>
                <Box display="flex" flexDirection="row" justifyContent="flex-end">
                  {recentEvents.length > 0 && (
                    <TableCorreiosDownload
                      mcm_id={IDMCM}
                    />
                  )}
                  <Select
                    type="mainSelect"
                    label="FILTRO"
                    name="filter"
                    choices={filters}
                    value={data.filter}
                    onChange={handleChange}
                  />
                </Box>
              </Grid>
            </Grid>

            {data.filter && (
              <Toolbar id="toolbar-period" style={{ marginTop: "16px" }}>
                <Grid container spacing={2} justifyContent="flex-end">
                  <Grid item xs={12} md={6}>
                    <Paper style={{ padding: "16px" }}>
                      {data.filter === "period" && (
                        <Grid container spacing={2} justifyContent="flex-end">
                          <Grid item xs={12} justifyContent="flex-end"></Grid>
                          <Grid item xs={6}>
                            <DateTimePicker
                              label="DE: "
                              name="dateFrom"
                              format="dd/MM/yyyy"
                              value={data.dateFrom}
                              onChange={(e) => handleDateChange(e, "dateFrom")}
                            />
                          </Grid>
                          <Grid item xs={6} justifyContent="flex-end">
                            <DateTimePicker
                              label="ATÉ: "
                              name="dateTo"
                              format="dd/MM/yyyy"
                              value={data.dateTo}
                              minDate={data.dateFrom}
                              minDateMessage={`A data deve ser maior ou igual a ${convertDate(
                                String(data.dateFrom)
                              )}`}
                              onChange={(e) => handleDateChange(e, "dateTo")}
                            />
                          </Grid>
                        </Grid>
                      )}
                      {data.filter === "status" && (
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={3}>
                            <Select
                              label="LOG"
                              name="status"
                              choices={eventsOptions}
                              value={data.status}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                      )}
                      <Box mt={3} display="flex" justifyContent="flex-end">
                        <ButtonCancel
                          onClick={handleCancelFilter}
                          style={{ marginRight: "16px" }}
                        >
                          LIMPAR
                        </ButtonCancel>
                        <ButtonSubmit autoFocus onClick={handleFilterClick}>
                          FILTRAR
                        </ButtonSubmit>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Toolbar>
            )}
          </Paper>

          {!loading ? (
            <Paper className={classes.table} elevation={0}>
              <Grid container alignItems="center">
                <Grid item xs={12} sm={6}>
                  <Box display="flex" alignItems="center" minHeight={48}>
                    <SelectedItems>
                      Exibindo {filterItens(recentEvents).length} de {eventsLength} registros
                    </SelectedItems>
                  </Box>
                </Grid>
              </Grid>

              {/* conteudo aqui */}
              {recentEvents && (
                <div style={{ marginTop: "20px" }}>
                  {filterItens(recentEvents).map(
                    (people: any, index: number) => (
                      <Paper elevation={1} style={{ marginTop: "20px" }}>
                        <AccordionItem
                          // isOpen={isOpen}
                          key={index}
                          index={index}
                          data={people}
                          events={eventsOptions}
                        />
                      </Paper>
                    )
                  )}
                </div>
              )}
            </Paper>
          ) : (
            <Box mt={15} mb={15}>
              <Loading />
            </Box>
          )}
        </>
      )}
      {pagination()}
    </>
  );
}
